<template>
	<div class="wrap">
		<Title :title="detailModel.vacationName"></Title>
		<table class="data-table">
			<tr>
				<td>CRS报告</td>
				<td style="width: 25%">{{reportData.csrUrlTime}}</td>
				<td style="width: 35%;">
					<div v-if="reportData.csrUrl">
						<span class="text-link" @click="getExportReport(1)" v-loading="loading1"
							element-loading-spinner="el-icon-loading" element-loading-text="重新生成中...">实时生成文件</span>
						<a class="text-link" href="javascript:;" @click="download(reportData.csrUrl, 1)">下载文件</a>
						<span class="text-link" @click="getCsrData">综合评述</span>
					</div>
					<div v-else>
						<span class="text-link" @click="getExportReport(1)" v-loading="loading1"
							element-loading-spinner="el-icon-loading" element-loading-text="生成中...">生成文件</span>
					</div>
				</td>
			</tr>
			<tr>
				<td>附件-触达的地区明细</td>
				<td>{{reportData.cityUrlTime}}</td>
				<td>
					<div v-if="reportData.cityUrl">
						<span class="text-link" @click="getExportReport(2)" v-loading="loading2"
							element-loading-spinner="el-icon-loading" element-loading-text="重新生成中...">实时生成文件</span>
						<a class="text-link" href="javascript:;" @click="download(reportData.cityUrl, 2)">下载文件</a>
					</div>
					<div v-else>
						<span class="text-link" @click="getExportReport(2)" v-loading="loading2"
							element-loading-spinner="el-icon-loading" element-loading-text="生成中...">生成文件</span>
					</div>
				</td>
			</tr>
			<tr>
				<td>附件-入选大学生名单</td>
				<td>{{reportData.studentUrlTime}}</td>
				<td>
					<div v-if="reportData.studentUrl">
						<span class="text-link" @click="getExportReport(3)" v-loading="loading3"
							element-loading-spinner="el-icon-loading" element-loading-text="重新生成中...">实时生成文件</span>
						<a class="text-link" href="javascript:;" @click="download(reportData.studentUrl, 3)">下载文件</a>
					</div>
					<div v-else>
						<span class="text-link" @click="getExportReport(3)" v-loading="loading3"
							element-loading-spinner="el-icon-loading" element-loading-text="生成中...">生成文件</span>
					</div>
				</td>
			</tr>
			<tr>
				<td>附件-受助者签收名单</td>
				<td>{{reportData.signUrlTime}}</td>
				<td>
					<div v-if="reportData.signUrl">
						<span class="text-link" @click="getExportReport(4)" v-loading="loading4"
							element-loading-spinner="el-icon-loading" element-loading-text="重新生成中...">实时生成文件</span>
						<a class="text-link" href="javascript:;" @click="download(reportData.signUrl, 4)">下载文件</a>
					</div>
					<div v-else>
						<span class="text-link" @click="getExportReport(4)" v-loading="loading4"
							element-loading-spinner="el-icon-loading" element-loading-text="生成中...">生成文件</span>
					</div>
				</td>
			</tr>
		</table>
		<div class="contract-info">
			<span>招募时间：{{detailModel.recruitStartTime|datefmt('YYYY-MM-DD')}} ~
				{{detailModel.recruitEndTime|datefmt('YYYY-MM-DD')}}</span>
			<div>招募范围：
				<span v-if="detailModel.recruitType==0">全国</span>
				<span v-else>{{detailModel.recruitNames}}</span>
			</div>
			<div>活动类型：
				<span v-if="detailModel.activityType==0">包裹发放</span>
				<span v-else>最美推荐</span>
				<span v-if="detailModel.deliveryType==0">(现场领取)</span>
				<span v-else>(邮寄配送)</span>
			</div>
		</div>
		<ul class="report-nav">
			<li>
				<span>{{entity.recruitNums}}</span>
				<span>招募人数</span>
			</li>
			<li>
				<span>{{entity.totalEnroll}}</span>
				<span>报名人数</span>
			</li>
			<li>
				<span>{{entity.recipients}}</span>
				<span>受助者</span>
			</li>
			<li>
				<span>{{entity.totalFeed}}</span>
				<span>产生动态</span>
			</li>
			<li>
				<span>{{entity.joinProvinceStatus}}</span>
				<span>触达省</span>
			</li>
			<li>
				<span>{{entity.joinCityStatus}}</span>
				<span>触达市</span>
			</li>
			<li>
				<span>{{entity.joinDistrictStatus}}</span>
				<span>触达县/区</span>
			</li>
			<li>
				<span>{{entity.joinSchoolStatus}}</span>
				<span>参与学校</span>
			</li>
		</ul>
		<Title title="活动数据报告"></Title>
		<div class="report-list-wrap">
			<div class="report-list">
				<div class="report-title">实际报名与入选数据</div>
				<div id="echarts1" style="width: 100%; height: 320px; margin-top: -20px;"></div>
			</div>
			<div class="report-list">
				<div class="report-title">实际物资发放与签收数据</div>
				<div id="echarts2" style="width: 100%; height: 320px; margin-top: -20px;"></div>
			</div>
		</div>
		<div class="report-list-wrap">
			<div class="report-list">
				<div class="report-title">应下载与已下载社会实践证书数据</div>
				<div id="echarts3" style="width: 100%; height: 320px; margin-top: -20px;"></div>
			</div>
			<div class="report-list">
				<div class="report-title">应产生与已完成动态数据</div>
				<div id="echarts4" style="width: 100%; height: 320px; margin-top: -20px;"></div>
			</div>
		</div>
		<!--综合评述弹窗-->
		<el-dialog title="综合评述" :visible.sync="crsDialog" width="50%" @close="crsDialog=false">
			<el-form :model="crsForm" :rules="crsFormRules" ref="crsForm">
				<el-form-item label="评述内容:" prop="confirmMessage">
					<el-input v-model="crsForm.csrContent" :rows="6" type="textarea" clearable></el-input>
				</el-form-item>
				<el-form-item>
					<div class="flex-end">
						<el-button size="mini" type="primary" @click="toConfirm">确定</el-button>
					</div>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>

</template>

<script>
	import Title from '@/components/titleAdmin'
	import qs from 'qs'
	import {
		post,
		config,
		ajaxParam
	} from '@/units/request.js'
	import * as echarts from 'echarts';
	export default {
		name: 'Report',
		components: {
			Title
		},
		data() {
			return {
				activityId: '',
				entity: {},
				detailModel: {},
				reportData: {},
				dataY1: [],
				dataY2: [],
				dataY3: [],
				dataY4: [],
				loading1: false,
				loading2: false,
				loading3: false,
				loading4: false,
				crsDialog: false,
				crsForm: {
					csrContent: '',
					confirmId: ''
				},
				crsFormRules: {
					csrContent: [{
						required: true,
						message: '请输入评述内容',
						trigger: 'blur'
					}]
				}
			}
		},
		created() {
			this.activityId = this.$route.query.id || ''
			this.getActivityDetail()
		},
		methods: {
			download(url, index) {
				let name = ''
				if (index == 1) {
					name = 'CRS报告'
				} else if (index == 2) {
					name = '附件-触达的地区明细'
				} else if (index == 3) {
					name = '附件-入选大学生名单'
				} else if (index == 4) {
					name = '附件-受助者签收名单'
				}
				let downUrl = config.baseUrl + 'admin/word/download?fileUrl=' + url + '&fileName=' + name
				window.location.href = downUrl
			},
			//生成csr报告
			async getExportReport(index) {
				let url = ''
				if (index == 1) {
					url = 'admin/word/exportCsr'
					this.loading1 = true
				} else if (index == 2) {
					url = 'admin/word/exportCity'
					this.loading2 = true
				} else if (index == 3) {
					url = 'admin/word/exportStudent'
					this.loading3 = true
				} else if (index == 4) {
					url = 'admin/word/exportSign'
					this.loading4 = true
				}
				let param = {
					vacationId: this.activityId
				}
				ajaxParam(param)
				const res = await post(url, qs.stringify(param))
				if (res.data.code == 200) {
					let entity = res.data.entity
					if (index == 1) {
						this.reportData.csrUrlTime = entity.time
						this.reportData.csrUrl = entity.url
						this.loading1 = false
					} else if (index == 2) {
						this.reportData.cityUrlTime = entity.time
						this.reportData.cityUrl = entity.url
						this.loading2 = false
					} else if (index == 3) {
						this.reportData.studentUrlTime = entity.time
						this.reportData.studentUrl = entity.url
						this.loading3 = false
					} else if (index == 4) {
						this.reportData.signUrlTime = entity.time
						this.reportData.signUrl = entity.url
						this.loading4 = false
					}
					this.$message.success('已生成文件(请去“下载文件”)')
				}
			},
			//综合评述
			async getCsrData() {
				this.crsDialog = true
				let param = {
					vacationId: this.activityId
				}
				ajaxParam(param)
				const res = await post('admin/word/getCsrData', qs.stringify(param))
				if (res.data.code == 200) {
					this.crsForm.csrContent = res.data.entity.csrContent
				}
			},
			// 修改评述
			toConfirm() {
				this.$refs.crsForm.validate(async valid => {
					if (valid) {
						//提交综合评述
						let param = {
							vacationId: this.activityId,
							csrData: this.crsForm.csrContent
						}
						console.log(param)
						ajaxParam(param)
						const res = await post('admin/word/updateCsrData', qs.stringify(param))
						if (res.data.code == 200) {
							this.$message.success('修改成功！')
							this.crsDialog = false
						}
					}
				})
			},
			//获取数据
			async getActivityDetail() {
				let param = {
					vacationId: this.activityId
				}
				ajaxParam(param)
				const res = await post('admin/vacation/getDataStatistics', qs.stringify(param))
				if (res.data.code == 200) {
					let entity = res.data.entity
					this.entity = entity
					this.detailModel = entity.vacation
					this.reportData = entity.reportData
					this.dataY1.push(entity.totalEnroll, entity.totalSelected)
					this.dataY2.push(entity.totalGrant, entity.totalSign)
					this.dataY3.push(entity.totalShouldDownloaded, entity.totalCertificate)
					this.dataY4.push(entity.totalShouldFeed, entity.totalFeed)
					this.drawEcharts1()
					this.drawEcharts2()
					this.drawEcharts3()
					this.drawEcharts4()
				}
			},
			drawEcharts1() {
				var chartDom = document.getElementById('echarts1');
				var myChart = echarts.init(chartDom);
				var option;
				option = {
					xAxis: {
						type: 'category',
						data: ['实际报名', '实际入选']
					},
					yAxis: {
						type: 'value'
					},
					series: [{
						data: this.dataY1,
						type: 'bar',
						barWidth: 50,
						itemStyle: {
							normal: {
								label: {
									show: true, //开启显示
									position: 'top', //在上方显示
									textStyle: { //数值样式
										color: '#666',
										fontSize: 12
									}
								}
							}
						}
					}]
				};
				option && myChart.setOption(option);
			},
			drawEcharts2() {
				var chartDom = document.getElementById('echarts2');
				var myChart = echarts.init(chartDom);
				var option;
				option = {
					xAxis: {
						type: 'category',
						data: ['实际发放', '实际签收']
					},
					yAxis: {
						type: 'value'
					},
					series: [{
						data: this.dataY2,
						type: 'bar',
						barWidth: 50,
						itemStyle: {
							normal: {
								label: {
									show: true, //开启显示
									position: 'top', //在上方显示
									textStyle: { //数值样式
										color: '#666',
										fontSize: 12
									}
								}
							}
						}
					}]
				};
				option && myChart.setOption(option);
			},
			drawEcharts3() {
				var chartDom = document.getElementById('echarts3');
				var myChart = echarts.init(chartDom);
				var option;
				option = {
					xAxis: {
						type: 'category',
						data: ['应下载', '已下载']
					},
					yAxis: {
						type: 'value'
					},
					series: [{
						data: this.dataY3,
						type: 'bar',
						barWidth: 50,
						itemStyle: {
							normal: {
								label: {
									show: true, //开启显示
									position: 'top', //在上方显示
									textStyle: { //数值样式
										color: '#666',
										fontSize: 12
									}
								}
							}
						}
					}]
				};
				option && myChart.setOption(option);
			},
			drawEcharts4() {
				var chartDom = document.getElementById('echarts4');
				var myChart = echarts.init(chartDom);
				var option;
				option = {
					xAxis: {
						type: 'category',
						data: ['应产生', '已完成']
					},
					yAxis: {
						type: 'value'
					},
					series: [{
						data: this.dataY4,
						type: 'bar',
						barWidth: 50,
						itemStyle: {
							normal: {
								label: {
									show: true, //开启显示
									position: 'top', //在上方显示
									textStyle: { //数值样式
										color: '#666',
										fontSize: 12
									}
								}
							}
						}
					}]
				};
				option && myChart.setOption(option);
			}
		}
	}
</script>

<style scoped lang="less">
	.wrap {
		background: #fff;
		border: 1px solid #e4e4e4;
		border-radius: 4px;
		margin-bottom: 10px;
		padding: 15px;
	}

	.contract-info {
		display: flex;
		justify-content: space-between;
		width: 70%;
		padding: 10px 0 20px;

		h3 {
			width: 50%;
			font-size: 18px;
			font-weight: bold;
		}
	}

	.report-nav {
		display: flex;
		flex-wrap: wrap;

		li {
			display: flex;
			flex-direction: column;
			align-items: center;
			width: 20%;
			margin: 20px 2.5%;
			padding: 20px 10px;
			background: #fafafa;
			border-radius: 5px;
			box-sizing: border-box;
			color: #666;

			span:nth-of-type(1) {
				padding-bottom: 8px;
				font-size: 30px;
			}
		}
	}

	.report-list-wrap {
		display: flex;

		.report-list {
			width: 50%;

			.report-title {
				margin: 10px 20px -20px;
				color: #666;
			}
		}
	}

	.data-table {
		width: 100%;
		margin: 20px 0;

		td {
			border: 1px solid #EBEEF5;
			padding: 15px 15px;
			font-size: 12px;

			.text-link {
				margin: 0 10px;
				color: #2A76CD;
				cursor: pointer;
			}
		}

		/deep/ .el-loading-spinner .el-loading-text {
			font-size: 12px;
		}
	}

	.flex-end {
		display: flex;
		justify-content: flex-end;
		padding-top: 20px;

		/deep/ .el-button--mini,
		.el-button--mini.is-round {
			padding: 4px 15px;
			font-size: 14px !important;
		}

	}

	/deep/ .el-form-item {
		margin-bottom: 0;
	}

	/deep/ .el-textarea__inner {
		font-size: 12px !important;
	}

	/deep/ .el-dialog__body {
		padding-top: 0;
	}
</style>